<div>
  <ng-content></ng-content>
</div>
<span>
  <sb-icon [name]="'down-regular'" [size]="'lg'" [class.hidden]="!toggleable()" />
</span>
